import React, { useState, useEffect, forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Add as AddIcon, Edit as EditIcon } from '@mui/icons-material'

import ApplicatonDialog from '../application/application/applicationDialog'

import {
  Button,
  Grid,
  Table,
  TableBody,
  TableHead,
  Card,
  Divider,
  Typography,
  Snackbar,
  Alert as MuiAlert,
  IconButton,
  Pagination,
  CardContent,
  TableContainer,
  TextField,
  Box
} from '@mui/material'
import { businessCheck } from '../../utils/utils'
import {
  SnackBarHideDuration,
  SnackBarTransition,
  StyledTableCell,
  StyledTableRow
} from '../../utils/ui_utils'
import {
  useApplicationCreate,
  useApplicationFetch,
  useApplicationUpdate
} from '../../modules/application/applicationHooks'
import {
  useFetchModuleInApplication,
  useModuleFetch
} from '../../modules/modules/modulesHooks'

function Application() {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(50)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const { loading, error, data, applicationFetch } = useApplicationFetch()
  const {
    applicationCreateData,
    applicationCreateLoading,
    applicationCreateError,
    applicationCreate
  } = useApplicationCreate()
  const [applicationDrawerMode, setapplicationDrawerMode] = useState('edit')
  const [applicationDrawerVisible, setApplicationDrawerVisible] =
    useState(false)
  const {
    applicationUpdateLoading,
    applicationUpdateError,
    applicationUpdateData,
    applicationUpdate
  } = useApplicationUpdate()
  const { moduleInApplicationFetchData, moduleInApplicationFetch } =
    useFetchModuleInApplication()
  const { moduleFetch, moduleFetchData } = useModuleFetch()
  const [initialValues, setInitialValues] = useState({})

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const handlePageChange = async (event, value) => {
    setPage(value)
    let payload = {
      pageNumber: value,
      limit: limit
    }
    applicationFetch(payload)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const history = useNavigate()

  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: page,
      limit: limit
    }
    applicationFetch(payload)
    let param = {
      pageNumber: 1,
      limit: 100
    }
    moduleFetch(param)
  }, [])

  // useEffect(() => {
  //   if (Object.keys(applicationapi.fetch.state.data).length > 0) {

  //     pageCount(applicationapi.fetch.state.totalRecords)
  //   }
  // }, [applicationapi.fetch.state.data])

  function ModulesInApplicationInfo() {
    if (moduleInApplicationFetchData.length !== 0) {
      return (
        <Grid container>
          <Grid item xs={6} md={7} lg={5}>
            <Card>
              <CardContent sx={{ flexGrow: 1 }}>
                <TableContainer component={Card}>
                  <Table size="small">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell align="center">
                          Module Name
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {moduleInApplicationFetchData.map((row) => (
                        <StyledTableRow key={row._id}>
                          <StyledTableCell
                            align="center"
                            component="th"
                            scope="row"
                          >
                            {row.module_name}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )
    } else return <></>
  }

  const getModulesInApplicationClick = (val) => {
    setInitialValues(val)
    let payload = {
      application_id: val._id,
      pageNumber: 1,
      limit: 100
    }
    moduleInApplicationFetch(payload)
  }

  if (error) return <p>Error!</p>
  if (loading) return <p>Loading...</p>
  return (
    <>
      <Helmet title="Application" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={9} md={6}>
          <Typography variant="h4" gutterBottom display="inline">
            Applications
          </Typography>
        </Grid>
        <Grid item>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              setapplicationDrawerMode('new')
              setApplicationDrawerVisible(true)
              setInitialValues({
                application_name: '',
                modules: []
              })
            }}
          >
            Add Application
          </Button>
          <ApplicatonDialog
            visible={applicationDrawerVisible}
            title={
              applicationDrawerMode == 'new'
                ? 'Add Application'
                : 'Edit Application'
            }
            initialValues={initialValues}
            okText={applicationDrawerMode == 'new' ? 'Create' : 'Update'}
            onSubmit={(value) => {
              let values = _.cloneDeep(value)
              if (applicationDrawerMode == 'new') {
                let modules = []
                for (let i = 0; i < values?.modules?.length; i++) {
                  modules.push(BigInt(values.modules[i]?._id))
                }
                values.modules = modules
                applicationCreate(values)

                if (applicationCreateError) {
                  toastMessage(applicationCreateError, 'error')
                  setApplicationDrawerVisible(true)
                } else if (applicationCreateData) {
                  toastMessage(applicationCreateData, 'success')
                  setApplicationDrawerVisible(false)
                  let payload = {
                    pageNumber: page,
                    limit: limit
                  }
                  applicationFetch(payload)
                }
              } else {
                let modules = []
                for (let i = 0; i < values?.modules?.length; i++) {
                  modules.push(BigInt(values.modules[i]?._id))
                }
                values.modules = modules
                values.id = values._id
                delete values._id
                delete values.key
                applicationUpdate(values)
                if (applicationUpdateError) {
                  toastMessage(applicationUpdateError, 'error')
                  setApplicationDrawerVisible(true)
                } else if (applicationUpdateData) {
                  toastMessage(applicationUpdateData, 'success')
                  setApplicationDrawerVisible(false)
                  let payload = {
                    pageNumber: page,
                    limit: limit
                  }
                  applicationFetch(payload)
                }
              }
            }}
            onClose={() => {
              setApplicationDrawerVisible(false)
            }}
            modulesData={moduleFetchData}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      <Grid container spacing={10} sx={{ paddingTop: 5 }}>
        <Grid item xs={5} lg={3}>
          <Card raised sx={{ borderRadius: 3 }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <TableContainer component={Card}>
                <Table size="small">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Application Name</StyledTableCell>
                      <StyledTableCell align="right">Edit</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row, i) => (
                      <StyledTableRow
                        key={i}
                        hover
                        onClick={() => getModulesInApplicationClick(row)}
                      >
                        <StyledTableCell>
                          {row.application_name}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          <IconButton
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setInitialValues(row)
                              setApplicationDrawerVisible(true)
                              setapplicationDrawerMode('edit')
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>{' '}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            {pagecount > 1 && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  p: 2,
                  backgroundColor: 'grey.50',
                  borderRadius: 1
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%'
                  }}
                >
                  <Pagination
                    count={pagecount}
                    page={page}
                    color="secondary"
                    size="small"
                    boundaryCount={2}
                    siblingCount={0}
                    showFirstButton
                    showLastButton
                    onChange={handlePageChange}
                    sx={{
                      '& .MuiPaginationItem-root': {
                        transition: 'all 0.2s ease-in-out'
                      }
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1.5,
                    backgroundColor: 'white',
                    p: 2,
                    borderRadius: 1,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': {
                      boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                    }
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 500 }}
                  >
                    Jump to
                  </Typography>
                  <TextField
                    size="small"
                    value={goToPageInput}
                    onChange={handleGoToPageChange}
                    onKeyPress={handleGoToPageKeyPress}
                    placeholder="Page"
                    sx={{
                      width: '80px',
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                        transition: 'all 0.2s ease-in-out',
                        '& fieldset': {
                          borderColor: 'grey.300',
                          borderWidth: '1px'
                        },
                        '&:hover fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '1.5px'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '2px',
                          boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.1)'
                        }
                      },
                      '& .MuiOutlinedInput-input': {
                        textAlign: 'center',
                        fontWeight: 500,
                        padding: '7px 8px',
                        height: '20px',
                        lineHeight: '20px'
                      }
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 400 }}
                  >
                    of {pagecount}
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleGoToPageSubmit}
                    disabled={
                      !goToPageInput ||
                      parseInt(goToPageInput, 10) < 1 ||
                      parseInt(goToPageInput, 10) > pagecount
                    }
                    sx={{
                      textTransform: 'none',
                      fontWeight: 500,
                      px: 2,
                      py: 0.75,
                      height: '34px',
                      lineHeight: 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                      },
                      '&:active': {
                        transform: 'translateY(0)'
                      }
                    }}
                  >
                    Go
                  </Button>
                </Box>
              </Box>
            )}
          </Card>
        </Grid>
        <Grid item xs={6}>
          <ModulesInApplicationInfo />
        </Grid>
      </Grid>
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}
export default Application
